import ThreePLSerialNumbers from './three-pl-serial-numbers-list-screen.vue';

export default {
    components: {
        'three_pl_serial_numbers': ThreePLSerialNumbers
    },

    data: function () {
        return {
            loading: false,
            appId: this.$route.params.id ?? 0,
            model: this.emptyModel(),
        }
    },

    computed: {

    },

    methods: {
        refreshScreen() {
            this.appId = this.$route.params.id ?? 0;
            this.senderId = this.$route.params.senderId ?? 0;
            this.onLoadModelDataSource();
        },

        emptyModel() {
            return {
                AppId: 0,
            }
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                let url = '/api/ui/three_pl_serial_numbers_applications/load/' + this.appId;
                let response = await this.$http.get(url);
                this.model = response.body;

                this.$refs.three_pl_serial_numbers.channelSettings = {
                    ApplicationId: this.model.AppId
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: function () {
        this.refreshScreen();
    }
}